<template>
  <TheMenuLayout>
    <PublicCGV />
  </TheMenuLayout>
</template>

<script>
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import PublicCGV from '@/views/PublicCGV.vue';

export default {
  name: 'CGU',
  components: {
    TheMenuLayout,
    PublicCGV,
  },
};
</script>
